module.exports = __webpack_public_path__ + "feea85c08b08f961ebced1810cd140dd.png";